
import { ref } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'FooterComponent',
  setup () {
    const footerType = ref<number | null>(null)
    const route = useRoute()
    const clientType = process.env.VUE_APP_CLIENT_TYPE as string

    const viewControl = (type: number) => {
      if (type === footerType.value) {
        footerType.value = null
      } else {
        footerType.value = type
      }
    }
    return {
      route,
      footerType,
      clientType,
      viewControl
    }
  }
}
